import type { FC } from "react";

import { useTranslation } from "src/translations";
import { type Voting, VotingStateEnum } from "src/types";
import { cn } from "src/utils";

type StatusDateMap = Record<VotingStateEnum, { label: string; date: string | null }>;

type VotingCardInfoDateProps = {
    votingItem: Voting;
    className?: string;
};

export const VotingCardInfoDate: FC<VotingCardInfoDateProps> = ({ votingItem, className }) => {
    const { t } = useTranslation();

    const votingDisplayDateMap: StatusDateMap = {
        [VotingStateEnum.Current]: {
            label: t("voting.card.info.date.closes"),
            date: votingItem.endAt ? t("format.localDate", { date: votingItem.endAt }) : null,
        },
        [VotingStateEnum.Future]: {
            label: t("voting.card.info.date.starts"),
            date: votingItem.startAt ? t("format.localDate", { date: votingItem.startAt }) : null,
        },
        [VotingStateEnum.Past]: {
            label: t("voting.card.info.date.ended"),
            date: votingItem.endAt ? t("format.localDate", { date: votingItem.endAt }) : null,
        },
    };

    const votingDateData = votingDisplayDateMap[votingItem.state!];

    return (
        votingDateData.date && (
            <p className={cn("text-sm text-secondary", className)}>
                {votingDateData.label} {votingDateData.date}
            </p>
        )
    );
};
